// Styles for HeaderTextCta go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledHeaderTextCta = styled.div`
  .header-text {
    &-heading {
      word-wrap: break-word;
    }

    [dir='rtl'] & {
      text-align: right;
      .ar-styles {
        padding-right: 0 !important;
      }
      a {
        margin-right: 0;
      }
    }
  }

  .header-text-cta-styles {
    padding: ${toRem(64)} 0;
    align-items: center;
    p {
      margin-bottom: 0;
    }
  }

  .header-eyebrow-styles {
    padding: ${toRem(32)} 0;
    align-items: center;
    p {
      margin-bottom: 0;
    }
  }

  .only-header-styles {
    padding: 0;
    align-items: center;
    p {
      margin-bottom: 0;
    }
  }
  .body-text {
    width: 100%;
    @media only ${baseVariables.mediaQuery.md} {
      width: 83%;
    }
    @media only ${baseVariables.mediaQuery.lg} {
      width: 66%;
    }
  }
  .header-text-cta-logo-container {
    width: 100%;
    padding: ${toRem(20)} 0;
    [data-component-name='m-ui-library-LogoContainer'] {
      margin: 0 auto;
    }
    span {
      font-size: ${toRem(50)};
    }
    .brand-logo-WH,
    .brand-logo-EB {
      font-size: ${toRem(24)};
    }
  }
  .header-text-eyebrow {
    padding-top: ${toRem(16)};
  }
`;
